import React, { useEffect } from 'react';
import Layout from './layout';


export default function List(props){

  return (
    <div className='case-container'>
      {props.cases.map( (CASE, i) => {
        return( 
          <React.Fragment key={i}>
            {(CASE.status == props.status.key)?
              <>{props.inverted?
                  <div className='case inverted'>
                    <Layout cases={props.cases} caseIndex={i} setCases={props.setCases} status={props.status.key} index={props.index} nurse={props.nurse} nurseList={props.nurseList} token={props.token}/>
                  </div>:
                  <div className='case'>
                    <Layout cases={props.cases} caseIndex={i} setCases={props.setCases} status={props.status.key} index={props.index} nurse={props.nurse} nurseList={props.nurseList} token={props.token}/>
                  </div>
                }
              </>:
              <></>
            }
          </React.Fragment>
        )
      })} 
    </div>
  )
}